export interface YouTubeProps {
  /** the video id, e.g. dQw4w9WgXcQ */
  id: string;
  title?: string;
}

/** Privacy-friendly, responsive 16:9 YouTube embed (no-cookie domain). */
export const YouTube = ({ id, title = 'YouTube video' }: YouTubeProps) => (
  <div className="my-6 aspect-video w-full overflow-hidden rounded-10 border border-line">
    <iframe
      className="h-full w-full"
      src={`https://www.youtube-nocookie.com/embed/${id}`}
      title={title}
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
);
